import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import * as api from '../../api/taskApi';

const mk = (name, fn) => createAsyncThunk(name, async (arg, { rejectWithValue }) => {
  try { return (await fn(arg)).data.data; } catch (e) { return rejectWithValue(e.response?.data?.message || 'Error'); }
});

export const fetchTasks        = mk('tasks/fetchAll',     () => api.getTasks());
export const fetchMyTasks      = mk('tasks/fetchMy',      () => api.getMyTasks());
export const fetchTask         = mk('tasks/fetchOne',     id => api.getTask(id));
export const createTask        = mk('tasks/create',       dto => api.createTask(dto));
export const updateTask        = mk('tasks/update',       ({id,dto}) => api.updateTask(id, dto));
export const updateTaskStatus  = mk('tasks/updateStatus', ({id,dto}) => api.updateTaskStatus(id, dto));
export const changeAssignee    = mk('tasks/changeAssignee',({id,dto}) => api.changeAssignee(id, dto));
export const addComment        = mk('tasks/addComment',   ({id,dto}) => api.addComment(id, dto));
export const requestApproval   = mk('tasks/requestApproval',({id,dto}) => api.requestApproval(id, dto));

const tasksSlice = createSlice({
  name: 'tasks',
  initialState: { list: [], selected: null, loading: false, error: null },
  reducers: { clearSelected: s => { s.selected = null; } },
  extraReducers: b => {
    const load  = s => { s.loading = true;  s.error = null; };
    const fail  = (s, { payload }) => { s.loading = false; s.error = payload; };
    const setList = (s, { payload }) => { s.loading = false; s.list = payload || []; };
    const setSel  = (s, { payload }) => { s.loading = false; s.selected = payload; };
    b.addCase(fetchTasks.pending, load).addCase(fetchTasks.fulfilled, setList).addCase(fetchTasks.rejected, fail);
    b.addCase(fetchMyTasks.pending, load).addCase(fetchMyTasks.fulfilled, setList).addCase(fetchMyTasks.rejected, fail);
    b.addCase(fetchTask.pending, load).addCase(fetchTask.fulfilled, setSel).addCase(fetchTask.rejected, fail);
    b.addCase(createTask.fulfilled, (s, {payload}) => { s.list.unshift(payload); });
    b.addCase(updateTask.fulfilled, (s, {payload}) => { const i = s.list.findIndex(t => t.id === payload.id); if (i >= 0) s.list[i] = payload; s.selected = payload; });
    b.addCase(updateTaskStatus.fulfilled, (s, {payload}) => { const i = s.list.findIndex(t => t.id === payload.id); if (i >= 0) s.list[i] = payload; s.selected = payload; });
    b.addCase(addComment.fulfilled, (s, {payload}) => { s.selected = payload; });
    b.addCase(requestApproval.fulfilled, (s, {payload}) => { s.selected = payload; });
  },
});
export const { clearSelected } = tasksSlice.actions;
export default tasksSlice.reducer;
